import usePayment from '@/usePayment';

import {
  _primaryControls,
  _increment,
  orderNumber,
  orderDate,
  status,
  paymentType,
  customerName,
  // eslint-disable-next-line
  area_id,
  address,
  totalWeight,
  deliveryFee,
  remarks,
  lastUpdatedBy,
  updatedAt,
  sortable,
} from './base';

const { translate: paymentMethodTranslate } = usePayment();

export default {
  types: {
    // _primaryControls,
    _selectorControls: {
      width: '2rem',
      name: 'SELECT',
    },
    _increment,
    orderNumber,
    orderDate,
    status,
    paymentType: {
      ...paymentType,
      filter: (val: string) => paymentMethodTranslate(val),
    },
    customerName,
    // eslint-disable-next-line
    area_id,
    address,
    totalWeight,
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '1fr',
      class: 'text-center',
    },
    deliveryFee,
    remarks,
    lastUpdatedBy,
    updatedAt,
  },
  sortable: [
    'orderNumber',
    'orderDate',
    'status',
    'paymentType',
    'customerName',
    'updatedAt',
  ],
};
